<template>
    <detail-header
        pretitle="Users"
        :title="user ? user.name : '&nbsp;'"
        :editable="true"
        :editMode="editMode"
        @editClick="onEditClick"
        @deleteClick="onDeleteClick"
        @saveClick="onSaveClick"
        @cancelClick="onCancelClick"
        @closeClick="$router.push('/admin/users')"
    />

    <div class="container-fluid">
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div v-if="successMessage" class="alert alert-success" role="alert">
            {{ successMessage }}
        </div>
        <div v-if="user">
            <div
                v-if="$store.getters.userRoles.isAccessByRole(generateTokenRoles)"
                class="d-flex justify-content-end mb-3"
            >
                <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="!showGenerateToken"
                    @click="showModal({ component: 'GenerateToken', data: { ...user } })"
                >
                    Generate Token
                </button>
            </div>
            <div class="card">
                <div class="card-body">
                    <form-fields
                        :fields="fields"
                        v-model="user"
                        :editMode="editMode"
                    />
                </div>
            </div>
        </div>
        <div v-else class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "../../components/DetailHeader.vue";
import Fields from "../../utils/field-constants/userFields";
import FormFields from "../../components/FormFields.vue";
import { mapActions } from "vuex";
export default {
    name: "User",
    components: { DetailHeader, FormFields },
    data() {
        return {
            editMode: false,
            user: null,
            snapshot: null,
            error: "",
            successMessage: "",
            generateTokenRoles: [1, 1.5],
        };
    },
    computed: {
        fields () {
            let fields = Fields;
            
            // custom update for role edit, if client_admin has the same scope or better it can update client_user to client_admin
            if(this.userRoleRank == 3) {
                if (this.user.cids.every(id => this.$store.state.currentUser.cids.includes(id))) {
                    let roleField = fields.find(item => item.name === 'roles')
                    roleField.readOnlyIfRoleOver = 3
                    roleField.options = ["client_user","client_admin"]
                }
            }

            return fields
        },
        userRoleRank() {
            return this.$store.getters.userRoles.userRoleRank;
        },
        showGenerateToken() {
            if (this.userRoleRank == 1) { // aqfer_admin only can generate token for anyone
                return true;
            }
            if (this.userRoleRank == 1.5) { // aqfer_manager can generate token for aqfer_manager, aqfer_user, client_admin, client_user
                return this.$store.getters.userRoles.getRoleRank(this.user.roles) >= 1.5
            }
            return false;
        }  
    },
    beforeMount() {
        this.fetchUser();
    },
    methods: {
        ...mapActions({
            readUser: "admin/readUser",
            updateUser: "admin/upsertUser",
            deleteUser: "admin/deleteUser",
            showModal: "showModal",
        }),
        setEditMode(mode) {
            this.editMode = mode;
            this.successMessage = null;
            this.error = null;
        },
        async fetchUser() {
            let response={};
            if(!this.$route.params.data){
                try {
                    response = await this.readUser(this.$route.params.id);
                } catch (error) {
                    if (error.response.data.error)
                        this.error = error.response.data.error;
                    else this.error = error.message;
                    return;
                }
            }else{
                response["data"] = JSON.parse(this.$route.params.data)
            }
            this.user = await response.data;
            this.snapshot = { ...this.user };
        },
        onCancelClick() {
            this.setEditMode(false);
            this.user = { ...this.snapshot };
            this.error = null;
        },
        onEditClick() {
            this.setEditMode(true);
        },
        onDeleteClick() {
            const self = this;
            this.showModal({
                component: "confirm",
                data: {
                    title: "Delete User",
                    message: `
                        Are you sure you want to delete <strong>${this.user.email}</strong>?
                        <div class="mt-3 py-3 px-3 rounded warning-alert" style="border-left: 4px solid #f59e0b; background-color: #ffc1071a;">
                            <span class="warning-alert-text">
                                <i class="fa fa-triangle-exclamation me-1"></i>
                                This action cannot be undone. Any tokens issued to the user will be invalidated
                            </span>
                        </div>`,
                    async confirm() {
                        try {
                            const response = await self.deleteUser(self.user);
                            self.$router.push("/admin/users");
                            return response;
                        } catch (error) {
                            if (error.response.data.error)
                                self.error = error.response.data.error;
                            else self.error = error.message;
                            return;
                        }
                    },
                },
            });
        },
        async onSaveClick() {
            var self = this
            try {
                const response = await this.updateUser(this.user);
                this.setEditMode(false);
                this.snapshot = { ...this.user };
                this.successMessage = "User updated successfully.";
            } catch (error) {
                if (error.response.data.error)
                    self.error = error.response.data.error;
                else self.error = error.message;
            }
        },
    },
};
</script>

<style>
.warning-alert-text {
    color: #f59e0b;
    font-size: 0.85rem;;
}
.warning-alert {
    border-left: 3px solid #f59e0b;
    background-color: #ffc1071a;
}
</style>
<style lang="scss">
body.dark-mode {
    .warning-alert-text {
        color: var(--bs-warning);
    }
    .warning-alert {
        border-left: 3px solid var(--bs-warning);;
    }
}
</style>